// extracted by mini-css-extract-plugin
module.exports = {"image_pd":"productImage_image_pd__hdQqw","image":"productImage_image__4SPp9"};